import gqlTagSwag from 'graphql-tag';

export const epicFragment = gqlTagSwag`
    fragment EpicPanelIssueParentFragment on IssueParent {
        id
        key
        summary
        color
        childrenInfo {
            todoStats {
                issueCount
            }
            inProgressStats {
                issueCount
            }
            doneStats {
                issueCount
            }
        }
        startDate
        dueDate
    }
`;

export const estimationInfoFragment = gqlTagSwag`
    fragment EstimationInfoFragment on EstimationInfo {
        details {
            estimationType
            name
        }
        childrenEstimationStats {
            doneEstimate
            totalEstimate
            percentageCompleted
            notEstimated
        }
    }
`;

export const createEpicFragment = gqlTagSwag`
    fragment CreateIssueParentFragment on IssueParent {
        id
        key
        summary
        color
        issueType {
            id
            name
            iconUrl
        }
        childrenInfo {
            todoStats {
                issueCount
            }
            inProgressStats {
                issueCount
            }
            doneStats {
                issueCount
            }
        }
        startDate
        dueDate
    }
`;
